import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IconStarFull from 'components/icons/iconStarFull';
import RatingAndReviewsWrapper from './RatingAndReviewsWrapper';
import RatingAndReviewsPlaceholder from './RatingAndReviewsPlaceholder';

const RatingAndReviews = ({
  href,
  loading = false,
  numberOfReviews,
  onClick,
  rating,
  size = 'xs',
}) => {
  if (loading) {
    return <RatingAndReviewsPlaceholder />;
  }

  if (!rating && !numberOfReviews) {
    return (
      <RatingAndReviewsWrapper>
        <div className="text-xs text-gray-light2">No reviews yet</div>
      </RatingAndReviewsWrapper>
    );
  }

  return (
    <RatingAndReviewsWrapper href={href} onClick={onClick}>
      <>
        {rating > 0 && (
          <>
            <span className="!mr-0">
              <IconStarFull
                className={classNames('h-[11px] w-[11px] mx-0.5 !mt-0', {
                  'md:h-[14px] md:w-[14px]': size === 'sm',
                })}
                stroke="transparent"
              />
            </span>

            <span
              className={classNames(
                'flex items-center min-h-[15px] text-xs font-bold text-gray-light1 mr-0.5 ml-1.5',
                {
                  'text-sm font-bold mr-2 md:text-base': size === 'sm',
                }
              )}
            >
              {rating}/5
            </span>
          </>
        )}

        {numberOfReviews > 0 && (
          <span
            className={classNames(
              'flex items-center min-h-[15px] text-xs text-gray-light1',
              {
                'text-xs md:text-sm': size === 'sm',
              }
            )}
          >
            ({numberOfReviews}
            <span className="!mr-0">
              &nbsp;review{numberOfReviews > 1 ? 's' : ''}
            </span>
            )
          </span>
        )}
      </>
    </RatingAndReviewsWrapper>
  );
};

RatingAndReviews.propTypes = {
  href: PropTypes.string,
  loading: PropTypes.bool,
  numberOfReviews: PropTypes.number,
  onClick: PropTypes.func,
  rating: PropTypes.number,
  size: PropTypes.oneOf(['xs', 'sm']),
};

export default RatingAndReviews;
